import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

/**
 * Team's own address: which tab, List or Chart, and the person open in the
 * right panel. The layout above draws the page, so the table behind the panel
 * and the invite dialog stays mounted.
 */
const search = z.object({
  tab: z.enum(['joined', 'invited']).optional(),
  view: z.enum(['list', 'chart']).optional(),
  person: z.string().optional(),
});

export type TeamSearch = z.infer<typeof search>;

export const Route = createFileRoute('/_app/business/_team/team')({ validateSearch: search, component: () => null });
